import React, { forwardRef, useState } from "react";
import { string, bool, func } from "prop-types";
import "./index.scss";
import { Tooltip, IconButton } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

const CustomInput = forwardRef(
  (
    {
      tooltipText,
      name,
      type,
      value,
      label,
      id,
      isRequired,
      onChange,
      placeholder,
      isDisabled,
      additionalClass,
      inputStyle,
      onBlur,
      onFocus,
      autoComplete,
    },
    ref
  ) => {
    const [passwordShown, setPasswordShown] = useState(false);

    const togglePasswordVisiblity = () => {
      setPasswordShown(!passwordShown);
    };

    return (
      <div
        className={`${
          inputStyle === "TextField" ? "custom-text-field" : "custom-input"
        } mt-4 w-100`}
      >
        <label className="d-block" htmlFor={id}>
          {label}
          {isRequired && <span className="co-lightred"> * </span>}
        </label>
        <div className="input-wrapper">
          <Tooltip title={tooltipText}>
            <input
              ref={ref}
              className={`w-100 ${additionalClass} ${type === "password" ? "pr-10" : ""}`}
              name={name}
              type={type === "password" ? (passwordShown ? "text" : "password") : type}
              value={value}
              id={id}
              required={isRequired}
              disabled={isDisabled}
              placeholder={placeholder}
              onChange={onChange}
              onBlur={onBlur ? onBlur : () => {}}
              onFocus={onFocus ? onFocus : () => {}}
              autoComplete={autoComplete || "off"}
            />
          </Tooltip>
          {type === "password" && (
            <IconButton
              aria-label="toggle password visibility"
              onClick={togglePasswordVisiblity}
              className="password-toggle-button"
              size="small"
            >
              {passwordShown ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          )}
        </div>
      </div>
    );
  }
);

CustomInput.propTypes = {
  value: string.isRequired,
  name: string,
  placeholder: string,
  additionalClass: string,
  id: string.isRequired,
  isRequired: bool,
  label: string,
  onChange: func,
  isDisabled: bool,
  type: string,
  tooltipText: string,
  inputStyle: string,
  onBlur: func,
  onFocus: func,
  autoComplete: string,
};

CustomInput.defaultProps = {
  isDisabled: false,
  isRequired: false,
  onChange: () => {},
  onBlur: () => {},
  onFocus: () => {},
  additionalClass: "",
  type: "",
  label: "",
  placeholder: "",
  name: "",
  tooltipText: "",
  autoComplete: "off",
};

CustomInput.displayName = "CustomInput";

export default CustomInput;
